import React from 'react'
import { Duty, DutyCardMetaProps } from '../data/types'
import { Button } from './ui/Button'
import { EditIcon, DeleteIcon, NegativeListDutyIcon } from '../icons'


type Props = {
    duty: Duty
    meta: DutyCardMetaProps
    onEdit?: (duty: Duty) => void
    onDelete?: (duty: Duty) => void,
    [x: string]: any;
}

export const DutyCard = (props: Props) => {
    const { duty, onEdit, onDelete } = props

    return (
        <div className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg">
            <div className="flex justify-between items-start mb-2">
                <div className='flex gap-2'>
                    <h5 className="font-semibold text-gray-900 dark:text-gray-100">
                        {duty.name}
                    </h5>
                    {duty.negative_list_member ? <NegativeListDutyIcon className='text-danger-500' /> : null}
                </div>
                {(onEdit || onDelete) && (
                    <div className="flex gap-1">
                        {onEdit && (
                            <Button onClick={() => onEdit(duty)} variant="icon" size="sm" title="Edit shift">
                                <EditIcon className="w-4 h-4" />
                            </Button>
                        )}
                        {onDelete && (
                            <Button onClick={() => onDelete(duty)} variant="icon" color="danger" size="sm" title="Delete shift">
                                <DeleteIcon className="w-4 h-4" />
                            </Button>
                        )}
                    </div>
                )}
            </div>
            {/* Description */}
            {duty.description ? (
                <div>
                    <p className="text-gray-800 dark:text-gray-200">
                        {duty.description}
                    </p>
                </div>
            ) : (
                <div>
                    <p className="text-gray-800 dark:text-gray-400">
                        No description available
                    </p>
                </div>
            )}
        </div>
    )

}
